module.exports = __webpack_public_path__ + "static/media/ali.9567984e.png";